<template lang="pug">
.BaseFormInputSkeleton.v-input.base-form-input-skeleton
  .v-input__control
    .v-input__slot.placeholder-loading
    .v-text-field__details
</template>

<script>
export default {
  name: 'BaseFormInputSkeleton',
  inheritAttrs: false,
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.base-form-input-skeleton
  ::v-deep .v-input__slot
    min-height: 40px
    border-radius: 2px
    margin-bottom: 16px
</style>
